import { useState } from "react";
import { Sparkles } from "lucide-react";
import { CURRENT_VERSION } from "../data/changelog.ts";
import ChangelogModal from "./ChangelogModal.tsx";

/**
 * Version number in the sidebar footer. Click to see what changed, described
 * from the user's point of view rather than as a technical log.
 * `compact` renders an icon only, for the collapsed sidebar.
 */
export default function VersionBadge({ compact = false }: { compact?: boolean }) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className={compact
          ? "flex justify-center w-full py-2 rounded-md text-muted-foreground/70 hover:text-muted-foreground hover:bg-accent transition-colors"
          : "w-full text-left px-3 py-1 text-[11px] text-muted-foreground/70 hover:text-muted-foreground transition-colors"}
        title={`v${CURRENT_VERSION}: see what has changed in this version`}
        aria-label="What's new"
      >
        {compact ? <Sparkles className="h-4 w-4" /> : <>v{CURRENT_VERSION} · What&apos;s new</>}
      </button>
      {open && <ChangelogModal onClose={() => setOpen(false)} />}
    </>
  );
}
